<template>
  <div class="content menu-wrap">
    <div class="menu-header">
      {{menuTitle}}
    </div>
    <ul class="menu-list">
      <li :class="current==item.id?'active':''" v-for="(item,index) in menuList" :key="index" @click="handleClick(item)">
        <a href="javascript:;">{{item.name}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "conMenu",
    props:{
      menuTitle: {
        type: String,
        default: '平台公告类型'
      },
      menuList: {
        type: Array,
        default: []
      },
      current: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        show: false,
      };
    },
    methods:{
      handleClick(row){
        this.$emit('handleMenuClick',row)
      }
    }
  }
</script>

<style scoped>
.menu-wrap {
    width: 268px;
    height: fit-content;
    background: #fff;
  }

  .menu-header {
    position: relative;
    padding: 0 20px;
    height: 56px;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    line-height: 56px;
    background-image: linear-gradient(#80C7F7, #3994DC);
    text-align: center;
  }

  .menu-list>li {
    text-align: center;
    display: block;
    font-weight: 700;
    padding: 0 20px;
    line-height: 65px;
    border-bottom: 1px dashed rgba(0, 0, 0, .2);
    font-size: 16px !important;
  }
  .menu-list>li a{
    font-size: 16px;
  }

  .menu-list>li.active,
  .menu-list>li:hover {
    color: #0080FF;
  }

  .menu-list>li.active a,
  .menu-list>li:hover a {
    color: #0080FF;
  }

  .menu-list>li>a {
    display: block;
    line-height: 65px;
    width: 100%;
    color: #333;
  }

  .menu-list>li.last,
  .menu-list>li:last-child {
    border-bottom: 0;
  }

</style>
